// extracted by mini-css-extract-plugin
export default {"ocher":"#908859","klein":"#002fa7","medium-grey":"#999","medium":"#757767","lightOrange":"#e0a648"};